"use strict";

exports.__esModule = true;
exports["default"] = _default;

function _default() {
  return typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function';
}

module.exports = exports.default;